export default {
  name: "BottomInfo",
  computed: {
    version: function version() {
      return process.env.VUE_APP_VERSION;
    }
  }
};